
import { TransferAssetMetadataBase } from './transfer-asset.metadata.base';


export class TransferAssetMetadata extends TransferAssetMetadataBase {
  constructor() {
    super();
  }
}

export const TRANSFER_ASSET_METADATA: TransferAssetMetadata = new TransferAssetMetadata();


